import * as Sentry from '@sentry/react'

/**
 * Inicializa Sentry si VITE_SENTRY_DSN está definido.
 * Si no hay DSN, no-op (la app funciona sin Sentry).
 *
 * IMPORTANTE: Replay con maskAllText:true y blockAllMedia:true
 * para evitar filtrar PII del CRM.
 */
export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN
  if (!dsn) return

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    // No enviar PII por defecto (IP, headers). Reforzamos con beforeSend que
    // limpia tokens en querystrings y descarta event.request.data por completo
    // (los breadcrumbs de fetch pueden incluir bodies en algunas versiones).
    sendDefaultPii: false,
    beforeSend(event) {
      if (event.request) {
        if (event.request.url) {
          try {
            const u = new URL(event.request.url)
            for (const k of ['access_token', 'token', 'code', 'state']) u.searchParams.delete(k)
            event.request.url = u.toString()
          } catch {
            /* URL no parseable: se deja como está */
          }
        }
        // Descarta cualquier body capturado por integraciones futuras.
        delete event.request.data
      }
      return event
    },
  })
}

/**
 * Re-export de Sentry.ErrorBoundary para envolver la app.
 */
export const SentryErrorBoundary = Sentry.ErrorBoundary
